import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function LeadSection() {
  return <section id="lead" className="py-14 md:py-32 bg-charcoal relative" data-id="element-157">
      <div className="max-w-3xl mx-auto px-6" data-id="element-158">
        <FadeIn data-id="element-159">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-sand mb-8 md:mb-12 text-center" data-id="element-160">
            Hay momentos en la vida en que todo debería estar bien.
          </h2>
        </FadeIn>

        <div className="space-y-5 md:space-y-8 text-base md:text-xl text-offwhite-dim leading-relaxed" data-id="element-161">
          <FadeIn delay={0.1} data-id="element-162">
            <p data-id="element-163">
              Tenés lo que necesitás. Sabés lo que querés. Conocés el camino.
            </p>
            <p className="mt-4 font-medium text-offwhite" data-id="element-164">
              Pero algo no cierra.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-165">
            <p data-id="element-166">
              Te levantás sin energía aunque dormiste. Empezás el día con
              intención y a las 2 horas ya perdiste el hilo. Hacés cosas, pero
              no sentís que avanzan. Estás presente en todo… y en nada al mismo
              tiempo.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-167">
            <p data-id="element-168">
              No es pereza. No es falta de voluntad. No es que "no tenés ganas".
            </p>
            <p className="mt-6 text-2xl font-heading font-bold text-amber" data-id="element-169">
              Es que estás desregulado.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-170">
            <p data-id="element-171">
              Tu cuerpo manda una señal. Tu mente manda otra. Y tu alma… lleva
              tiempo sin que la escuches.
            </p>
            <p className="mt-4" data-id="element-172">
              Cuando esas 3 cosas no van juntas, nada fluye en armonía.
            </p>
          </FadeIn>

          <FadeIn delay={0.5} data-id="element-173">
            <p data-id="element-174">
              Las relaciones se tensan. El trabajo se siente pesado. Los hábitos
              no duran. La paz se escapa justo cuando creés que la tenés.
            </p>
            <p className="mt-4" data-id="element-175">
              Y lo más confuso es esto: no podés señalar exactamente qué está
              mal.
            </p>
            <p className="mt-4 font-medium text-offwhite" data-id="element-176">
              Porque no hay una sola cosa.{' '}
              <span className="text-sand" data-id="element-177">Es todo un poco desalineado.</span>
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}